interface Props {
  data: Record<string, unknown>;
}

export const JsonView = ({ data }: Props) => {
  return <pre>{JSON.stringify(data, null, 2)}</pre>;
};
